import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-request',
  templateUrl: './feature-request.component.html',
  styleUrls: ['./feature-request.component.scss']
})
export class FeatureRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
